<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'

@Component({})
export default class SpaceSettingsHelpIcon extends Vue {
  open = false
}
</script>

<template>
  <span>
    <font-awesome-icon
      @click="open = true"
      icon="info-circle"
      class="fa-fw text-black-50 fa-sm cursor-pointer" />

    <b-modal v-model="open" centered>
      <h2 class="mb-4">Caregiver Roles</h2>

      <h4>Account Owner (<img src="@/assets/icons/caregiver-owner.svg" class="fa-fw" />)</h4>
      <ul>
        <li>Manages billing</li>
        <li>Can add other family caregivers, professional caregivers, or guests</li>
        <li>Editing privileges for all Health Card information</li>
        <li>Messaging</li>
      </ul>

      <h4>Family Caregiver</h4>
      <ul>
        <li>Can add other family caregivers, professional caregivers, or guests</li>
        <li>Editing privileges for all Health Card information</li>
        <li>Messaging</li>
      </ul>

      <h4>Professional Caregiver</h4>

      <ul>
        <li>Can add other professional caregivers or guests</li>
        <li>Editing privileges for all Health Card information pertaining to medication</li>
        <li>Messaging</li>
        <li>On/Off duty switch notifying the Care Circle</li>
      </ul>

      <h4>Guests</h4>
      <ul>
        <li>Can add other guests</li>
        <li>Messaging</li>
      </ul>

      <p>
        In the event of an emergency, the Response Team will attempt to contact users with this
        symbol (<img src="@/assets/icons/caregiver-primary.svg" class="fa-fw" />) next to their name
        before EMT dispatch.
      </p>

      <template #modal-footer="{ok, cancel, hide}">
        <b-btn variant="primary" @click="hide()" class="btn-block" size="lg">Okay</b-btn>
      </template>
    </b-modal>
  </span>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';

img.fa-fw {
  font-size: 75%;
}

p {
  font-size: 120%;
  color: $body-color;
}
ul li {
  font-size: 110%;
}
</style>
